import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input, Button } from 'loyal-react'
import { genderTypes } from 'Participant'
import moment from 'moment'
import { validate as validateCPF } from 'gerador-validador-cpf'

class ProfileInfos extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isValid: true,
      name: {
        value: this.props.participant.name.value && this.props.participant.name.value.substr(0, this.props.participant.name.value.indexOf(' ')),
        disabled: this.props.participant.name.disabled,
        error: this.props.participant.name.error
      },
      lastname: {
        value: this.props.participant.name.value && this.props.participant.name.value.split(' ').slice(1, 8).join(' '),
        disabled: this.props.participant.name.disabled,
        error: this.props.participant.name.error
      },
      cpf: {
        value: process.env.REACT_APP_RESTRICT_EMPTY_CPF ? '' : this.props.participant.cpf.value
      },
      email: this.props.participant.email,
      birthDate: this.props.participant.birthDate,
      phone: {
        value: this.props.participant.phones.home && this.props.participant.phones.home.number
          ? `${this.props.participant.phones.home.areaCode}${this.props.participant.phones.home.number}`
          : '',
        disabled: this.props.participant.phones.home.disabled
      },
      mobilePhone: {
        value: `${this.props.participant.phones.mobile.areaCode}${this.props.participant.phones.mobile.number}`,
        disabled: this.props.participant.phones.mobile.disabled
      },

      buttonNext: React.createRef()
    }
  }

  componentDidMount () {
    this.isValid()
  }

  isValid = () => {
    let isValid = true
    const mailValidator = /^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+)$/gim
    const { name, lastname, cpf, email, birthDate, mobilePhone } = this.state

    if (!name.value.trim()) {
      this.setState({
        name: {
          value: name.value,
          disabled: name.disabled,
          error: 'Digite seu nome',
          errorIcon: 'icon'
        }
      })
      isValid = false
    }

    if (!lastname.value.trim()) {
      this.setState({
        lastname: {
          value: lastname.value,
          disabled: lastname.disabled,
          error: 'Digite seu sobrenome'
        }
      })
      isValid = false
    }

    if (!validateCPF(cpf.value)) {
      this.setState({
        cpf: {
          value: cpf.value,
          disabled: cpf.disabled,
          error: 'Digite um CPF válido'
        }
      })
      isValid = false
    }

    if (!mailValidator.test(email.value)) {
      this.setState({
        email: {
          value: email.value,
          disabled: email.disabled,
          error: 'Digite um e-mail válido'
        }
      })
      isValid = false
    }

    const birthDateVerify = moment(birthDate.value, 'DD/MM/YYYY', true)
    if (!birthDateVerify.isValid()) {
      this.setState({
        birthDate: {
          value: birthDate.value,
          disabled: birthDate.disabled,
          error: 'Digite uma data de nascimento válida'
        }
      })
      isValid = false
    }

    if (!mobilePhone.value) {
      this.setState({
        mobilePhone: {
          value: mobilePhone.value,
          disabled: mobilePhone.disabled,
          error: 'Digite um celular válido'
        }
      })
      isValid = false
    }

    this.setState({ isValid })
    return isValid
  }

  transformMobile = (number) => {
    return number.length === 11 ? number.replace(number.charAt(2), '') : number
  }

  handleConfirm = () => {
    if (!this.isValid()) return

    const { buildPhone, setCustomer, participant } = this.props
    const { name, lastname, cpf, email, phone, birthDate, mobilePhone } = this.state

    let phones = [
      buildPhone(mobilePhone.value, 'MOBILE'),
      buildPhone(phone.value || this.transformMobile(mobilePhone.value), 'HOME')
    ]

    const completeName = `${name.value.trim()} ${lastname.value.trim()}`

    const customer = {
      name: completeName,
      documentNumber: cpf.value,
      email: email.value,
      genderType: genderTypes[participant.genderType.value],
      personType: 'INDIVIDUAL',
      birthDate: moment(birthDate.value, 'DD/MM/YYYY').format('YYYY/MM/DD'),
      phones
    }
    setCustomer(customer)
  }

  handleInputValid (input) {
    if (input.error) return false

    return null
  }

  handleInputChange = event => {
    this.setState({
      [event.target.name]: { value: event.target.value }
    })
  }

  handleKeyPress = (e, element) => {
    let inputIndex = element
    const inputOrder = [
      'input-name-profile-data',
      'input-lastname-profile-data',
      'input-cpf-profile-data',
      'input-email-profile-data',
      'input-birthDate-profile-data',
      'input-mobilePhone-profile-data',
      'input-phone-profile-data',
      'next-button'
    ]

    let isDisabled = true

    while (isDisabled) {
      if (inputOrder[inputIndex] === 'next-button') {
        isDisabled = false
      } else {
        let input = document.querySelector(`#${inputOrder[inputIndex]}`)
        if (input.getAttribute('disabled') === null || input.getAttribute('disabled') === undefined) {
          isDisabled = false
        } else {
          inputIndex++
        }
      }
    }

    // eslint-disable-next-line no-unused-expressions
    if (e.key === 'Enter') {
      if (inputIndex) {
        e.target.blur()
        document.querySelector(`#${inputOrder[inputIndex]}`) &&
          document.querySelector(`#${inputOrder[inputIndex]}`).focus()
      }
    }
  }

  render () {
    return (
      <div className='row px-0 pb-2 space-m'>
        <div className='profile-infos col-12 px-1 border-top border-color-ui-2'>
          <div className='row mx-0'>
            <Input
              id='input-name-profile-data'
              label='Nome*'
              ref={this.state.inputNameRef}
              className='col-12 col-md-6 mt-2'
              minLength='1'
              maxLength='50'
              name='name'
              data-error={this.state.name.error}
              valid={this.handleInputValid(this.state.name)}
              onChange={this.handleInputChange}
              value={this.state.name.value}
              disabled={this.state.name.disabled === 'true'}
              onKeyPress={(e) => this.handleKeyPress(e, 1)}
              onBlur={this.isValid}
              aria-describedby={this.state.name.error && 'error-name'}
            />

            <Input
              id='input-lastname-profile-data'
              label='Sobrenome*'
              className='col-12 col-md-6 mt-2'
              minLength='1'
              maxLength='50'
              name='lastname'
              data-error={this.state.lastname.error}
              valid={this.handleInputValid(this.state.lastname)}
              onChange={this.handleInputChange}
              value={this.state.lastname.value}
              disabled={this.state.lastname.disabled === 'true'}
              onKeyPress={(e) => this.handleKeyPress(e, 1)}
              onBlur={this.isValid}
              aria-describedby={this.state.lastname.error && 'error-name'}
            />

            <Input
              id='input-cpf-profile-data'
              label='CPF*'
              ref={this.state.inputCPFRef}
              className='col-12 col-md-6 mt-2'
              mask={[
                /\d/,
                /\d/,
                /\d/,
                '.',
                /\d/,
                /\d/,
                /\d/,
                '.',
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/
              ]}
              name='cpf'
              data-error={this.state.cpf.error}
              valid={this.handleInputValid(this.state.cpf)}
              onChange={this.handleInputChange}
              value={this.state.cpf.value}
              disabled={this.state.cpf.disabled === 'true'}
              onKeyPress={(e) => this.handleKeyPress(e, 2)}
              onBlur={this.isValid}
              type='text'
              inputMode='numeric'
              aria-describedby={this.state.cpf.error && 'error-cpf'}
            />

            <Input
              id='input-email-profile-data'
              label='E-mail*'
              ref={this.state.inputEmailRef}
              className='col-12 col-md-6 mt-2'
              name='email'
              type='email'
              inputMode='email'
              data-error={this.state.email.error}
              valid={this.handleInputValid(this.state.email)}
              onChange={this.handleInputChange}
              value={this.state.email.value}
              disabled='true'
              onKeyPress={(e) => this.handleKeyPress(e, 3)}
              onBlur={this.isValid}
              aria-describedby={this.state.email.error && 'error-email'}
            />

            <Input
              id='input-birthDate-profile-data'
              label='Data de nascimento*'
              ref={this.state.inputDateRef}
              className='col-12 col-md-6 mt-2'
              name='birthDate'
              mask={[
                /[0-3]/,
                /[0-9]/,
                '/',
                /[0-1]/,
                /[0-9]/,
                '/',
                /[1-2]/,
                /[0-9]/,
                /[0-9]/,
                /[0-9]/
              ]}
              data-error={this.state.birthDate.error}
              valid={this.handleInputValid(this.state.birthDate)}
              onChange={this.handleInputChange}
              value={this.state.birthDate.value}
              disabled={this.state.birthDate.disabled === 'true'}
              onKeyPress={(e) => this.handleKeyPress(e, 4)}
              onBlur={this.isValid}
              aria-describedby={this.state.birthDate.error && 'error-birthDate'}
            />

            <Input
              id='input-mobilePhone-profile-data'
              label='Celular*'
              ref={this.state.inputCelRef}
              className='col-12 col-md-6 mt-2'
              mask={[
                '(',
                /[1-9]/,
                /\d/,
                ')',
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                /\d/,
                /\d/
              ]}
              data-error={this.state.mobilePhone.error}
              valid={this.handleInputValid(this.state.mobilePhone)}
              onChange={this.handleInputChange}
              name='mobilePhone'
              value={this.state.mobilePhone.value}
              disabled={this.state.mobilePhone.disabled === 'true'}
              onKeyPress={(e) => this.handleKeyPress(e, 5)}
              onBlur={this.isValid}
              type='text'
              inputMode='numeric'
              aria-describedby={this.state.mobilePhone.error && 'error-mobilePhone'}
            />

            <Input
              id='input-phone-profile-data'
              label='Telefone'
              ref={this.state.inputTelRef}
              className='col-12 col-md-6 mt-2'
              aria-required
              mask={[
                '(',
                /[0-9]/,
                /\d/,
                ')',
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                /\d/,
                /\d/
              ]}
              name='phone'
              onChange={this.handleInputChange}
              value={this.state.phone.value}
              disabled={this.state.phone.disabled === 'true'}
              onKeyPress={(e) => this.handleKeyPress(e, 6)}
              onBlur={this.isValid}
            />

            <div className='col-12 offset-md-12 col-md-12 mt-2'>
              <Button
                className='btn btn-sm btn-featured btn-continuar'
                disabled={!this.state.isValid}
                onClick={() => {
                  this.handleConfirm()
                  this.props.forceFocus()
                }
                }
                text='Continuar para o endereço'
                id='next-button'
                ref={this.state.buttonNext}
              />
            </div>

            <div className='float-button bg-white px-2 py-2 row mx-0 d-none'>
              <div className='col-12 px-0'>
                <Button
                  className='btn btn-sm btn-featured'
                  disabled={!this.state.isValid}
                  onClick={() => {
                    this.handleConfirm()
                    this.props.forceFocus()
                  }
                  }
                  text='Próximo'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const valueType = PropTypes.shape({
  value: PropTypes.string.isRequired,
  disabled: PropTypes.string.isRequired,
  error: PropTypes.bool
})

ProfileInfos.propTypes = {
  participant: PropTypes.shape({
    name: valueType,
    cpf: valueType,
    email: valueType,
    birthDate: valueType,
    phones: PropTypes.object,
    genderType: PropTypes.object
  }).isRequired,
  setCustomer: PropTypes.func.isRequired,
  buildPhone: PropTypes.func.isRequired,
  forceFocus: PropTypes.func.isRequired
}

export default ProfileInfos



// WEBPACK FOOTER //
// ./src/features/Checkout/ProfileInfos/Individual.js